import { Card as BaseCard } from "../vendor/Card/Card.jsx";

export type CardProps = {
  /**
   * The content to render within the element.
   */
  children?: React.ReactNode | undefined;

  /**
   * A class property to attach to the element.
   *
   * @see {@link !Element.className}
   */
  className?: string | undefined;

  /**
   * <!-- TODO(ndhoule): Document me -->
   */
  variant?: "hero" | "bottomless" | undefined;
};

/**
 * A Card is a grouping element that renders its contents within a box that is visually distinct
 * from the rest of the page.
 *
 * ![Card](./screenshots/card.png)
 *
 * @param props
 * @see {@link CardTitle}
 * @see {@link CardFooter}
 */
export const Card = (props: CardProps) => <BaseCard {...props} />;
